import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  getCampaignElementById,
  getHasUploadedVideoForQuestionId,
  getHasVideoBucketUploadFailed,
  getIsQuestionPreview,
  getMediaSubmissionIdForElement,
  showFullQuestion,
} from '../../redux/modules/campaignLandingPage';
import { VpHoverInfo } from '@vp-ui/components';
import styles from './QuestionPreview.module.less';

const VIDEO_STATUS = Object.freeze({
  SUCCESS: {
    icon: 'CheckCircle',
    label: 'Video was successfully received.',
    color: 'greenMain'
  },
  ERROR: {
    icon: 'XCircle',
    label: 'There was an error uploading a video, please try again.',
    color: 'redMain'
  },
  EMPTY: {
    icon: 'AlertCircle',
    label: 'No video was received for this question. Please click here to add a response.',
    color: 'yellowMain'
  }
});

const getVideoStatus = (hasUploadFailure, hasUploadedVideo) => {
  if(hasUploadFailure) return VIDEO_STATUS.ERROR
  if(hasUploadedVideo) return VIDEO_STATUS.SUCCESS
  return VIDEO_STATUS.EMPTY;
}

const QuestionPreview = ({
  _showFullQuestion,
  isPreview,
  question,
  qid,
  hasUploadedVideo,
  hasUploadFailure
}) => {
  const hide = `${!isPreview && styles.vpHide}`;

  const videoStatus = getVideoStatus(hasUploadFailure, hasUploadedVideo);

  return (
    <>
      <Icon
        className={`${styles.vpTogglePreview} ${hide} ${styles.vpCursorPointer}`}
        icon="down"
        onClick={() => _showFullQuestion(qid)}
      />
      <section
        className={`${styles.vpQuestionPreviewHeader} ${hide} ${styles.vpCursorPointer}`}
        data-testid="questionShowToggle"
        onClick={() => _showFullQuestion(qid)}
      >
        <h4 className={styles.vpQuestionPreviewTitle}>
          {question.label}
        </h4>
        <VpHoverInfo
          icon={videoStatus.icon}
          label={videoStatus.label}
          className={`${hide}`}
          iconProps={{ iconColor: videoStatus.color }}
        />
      </section>
    </>
  );
};

QuestionPreview.propTypes = {
  _showFullQuestion: PropTypes.func,
  _updateMediaSubmissionStatus: PropTypes.func,
  isPreview: PropTypes.bool,
  mediaSubmissionId: PropTypes.string,
  question: PropTypes.object,
  qid: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  return {
    question: getCampaignElementById(state, ownProps.qid),
    isPreview: getIsQuestionPreview(state, ownProps.qid),
    mediaSubmissionId: getMediaSubmissionIdForElement(state, ownProps.qid),
    hasUploadedVideo: getHasUploadedVideoForQuestionId(state, ownProps.qid),
    hasUploadFailure: getHasVideoBucketUploadFailed(state, ownProps.qid)
  };
}

const mapDispatchToProps = {
  _showFullQuestion: showFullQuestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionPreview);




// WEBPACK FOOTER //
// ./src/components/CampaignLanding/QuestionPreview.jsx